export default __webpack_public_path__ + "static/media/Gitlab.05082217.svg";